import { render, staticRenderFns } from "./AlarmDecoderEventSetup.vue?vue&type=template&id=5c6ecf4f&scoped=true"
import script from "./AlarmDecoderEventSetup.vue?vue&type=script&lang=ts"
export * from "./AlarmDecoderEventSetup.vue?vue&type=script&lang=ts"
import style0 from "./AlarmDecoderEventSetup.vue?vue&type=style&index=0&id=5c6ecf4f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6ecf4f",
  null
  
)

export default component.exports